export default __webpack_public_path__ + "static/author-kunal-c62e5f2fe28167ff7c7b29a1212e5bc3.png";